import React from "react";
import { rows } from "colbi_web_ui/lib/components";
import StagingErrorCell from "./StagingErrorCell";
import StagingSuggestionCell from "./StagingSuggestionCell";

const { CellCard } = rows;

const getPlainValue = (value) => {
    if (value && typeof value === "object" && value.stagingCellKind) {
        return value.displayValue;
    }
    return value;
};

const StagingDataCellCard = ({
    onAcceptSuggestion,
    onFinalizeSuggestionAccept,
    onRejectSuggestion,
    suggestionDetailsByKey,
    type,
    value,
}) => {
    if (value?.stagingCellKind === "aiSuggestion") {
        const suggestion = suggestionDetailsByKey?.get(value.suggestionKey) ?? null;

        return (
            <StagingSuggestionCell
                displayValue={value.displayValue}
                onAccept={onAcceptSuggestion}
                onFinalizeAccept={onFinalizeSuggestionAccept}
                onReject={onRejectSuggestion}
                suggestion={suggestion}
            />
        );
    }

    if (value?.stagingCellKind === "error") {
        return (
            <StagingErrorCell displayValue={value.displayValue} />
        );
    }

    return <CellCard type={type === "customComponent" ? "" : (type || "")} value={getPlainValue(value)} />;
};

export default StagingDataCellCard;
